import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userDetailsReducer from "../features/UserDetailsSlice";
import accessTokenReducer from "../features/AccessTokenSlice";
import controllerCodeReducer from "../features/controllerCodeSlice";
import config from "../features/configSlice";
import loader from "../features/LoaderSlice";
import TrackerReducer from "../features/TrackerSlice";
import contentLibraryReducer from "../features/contentLibrarySlice";
import cocoConfigDetailsReducer from "../features/CocoConfigurationSlice";
import digitalIdentityReducer from "../features/digitalIdentitiesSlice";
import typesReducer from "../features/typesSlice";
import controllersReducer from "../features/controllerSlice";
import controllerConfig from "../features/controllerConfigSlice";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionStorage from "redux-persist/lib/storage/session";
import persistStore from "redux-persist/es/persistStore";

const localPersistConfig = {
  key: "local",
  storage,
};
const sessionPersistConfig = {
  key: "root",
  version: 1,
  storage: sessionStorage,
  whitelist: ["TrackerReducer", "userDetailsReducer"],
};

const allReducer = {
  userDetailsReducer,
  accessTokenReducer,
  controller: controllerCodeReducer,
  loader,
  TrackerReducer,
  config,
  contentLibrary: contentLibraryReducer,
  cocoConfigDetailsReducer,
  digitalIdentities: digitalIdentityReducer,
  controllers: controllersReducer,
  controllerConfig,
  types: persistReducer(localPersistConfig, typesReducer),
};

const persistedReducer = persistReducer(
  sessionPersistConfig,
  combineReducers(allReducer)
);
const store = configureStore({
  reducer: persistedReducer,
});

const persistor = persistStore(store);

export { store, persistor };
